import block from './block.json';

export const accordionThemeAttributes = {
	backgroundColor: '@tokens.variants.default.cardBackgroundColor',
	border: {
		color: '@tokens.variants.default.cardBorderColor',
		width: '1px',
		radius: {
			topLeft: [0, 0],
			topRight: [0, 0],
			bottomRight: [0, 0],
			bottomLeft: [0, 0],
		},
	},
	padding: {
		top: [10, 20],
		right: [60, 80],
		bottom: [10, 20],
		left: [10, 20],
	},
	title: {
		color: '@tokens.variants.default.cardTitleColor',
		typography: '@tokens.typographies.heading-3',
	},
	categoryTitle: {
		color: '@tokens.variants.default.cardTitleColor',
		typography: '@tokens.typographies.heading-6',
	},
	icon: {
		width: [18, 18],
		height: [18, 18],
		color: '@tokens.variants.default.cardTitleColor',
	},
	content: {
		color: '@tokens.variants.default.cardContentColor',
		typography: '@tokens.typographies.paragraph',
		border: { color: '@tokens.variants.default.cardBorderColor' },
	},
	states: {
		hover: {}, // adds hover state
		focus: {}, // adds focus state
		active: {}, // adds active state
	},
};

export const AccordionThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: accordionThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
